/* ═══════════════════════════════════════════════════════════════════════════
   chat-inputs.js  ·  Inputs (chat frontend)   [Shopify asset: eoh-chat-inputs.js]

   One standalone module for the whole Chat Inputs feature set. NO edits to
   eoh-chat.js except a single documented merge line for slash commands.

   Features (each gated by its feature flag via GET /chat-inputs/features):
     • Prompt Starters  — chips in the welcome card (chat_prompt_starters)
     • Slash Commands   — admin "/" commands merged into the native menu (chat_slash_commands)
     • @-Context        — attach a saved project / generated file into a prompt (chat_context_attach)
     • Limit Meter      — attachment counts + max size in the upload bar (chat_input_limit_meter)
     • Drag-and-Drop    — drop files on the input area to upload (chat_drag_drop_upload)

   Reuses page globals: setQ, sendMsg_fromWelcome, handleFile, handleMultiImages,
   #vs/#ps, #chat-ta, #text-input-area, #upload-bar.

   Load AFTER eoh-chat.js:
     <script src="{{ 'eoh-chat-inputs.js' | asset_url }}" defer></script>
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  var _dev = window.location.pathname.indexOf('/pages/erp-chat_dev') !== -1
          || window.location.search.indexOf('preview_theme_id=159788171482') !== -1
          || window.location.hostname !== 'erponlinehub.com';
  var API = (window.location.hostname === 'erponlinehub.com' && !_dev)
    ? 'https://erp-ai-backend.vercel.app'
    : 'https://erp-ai-backend-dev.vercel.app';

  var _flags = {};

  function _tok()  { try { return localStorage.getItem('eoh_t') || ''; } catch (_) { return ''; } }
  function _auth() { var h = {}; var t = _tok(); if (t) h['Authorization'] = 'Bearer ' + t; return h; }
  function _esc(s) { return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  async function _getJSON(url) { try { var r = await fetch(url, { headers: _auth() }); if (!r.ok) return null; return await r.json(); } catch (_) { return null; } }
  async function _getJSONTimeout(url, ms) {
    var ctl = ('AbortController' in window) ? new AbortController() : null;
    var t = ctl ? setTimeout(function () { ctl.abort(); }, ms || 15000) : null;
    try { var r = await fetch(url, { headers: _auth(), signal: ctl ? ctl.signal : undefined }); if (!r.ok) return null; return await r.json(); }
    catch (_) { return null; } finally { if (t) clearTimeout(t); }
  }
  function _ctxNote(text) {
    var n = document.getElementById('eoh-ctx-note');
    if (!text) { if (n) n.remove(); return; }
    if (!n) {
      n = document.createElement('div'); n.id = 'eoh-ctx-note';
      n.style.cssText = 'position:fixed;left:50%;transform:translateX(-50%);bottom:96px;z-index:9999;background:var(--bg2);border:1px solid var(--border);color:var(--text);border-radius:8px;padding:8px 14px;font-size:12px;box-shadow:0 6px 24px rgba(0,0,0,.35)';
      document.body.appendChild(n);
    }
    n.textContent = text;
  }
  function _sel() {
    var vs = document.getElementById('vs'), ps = document.getElementById('ps');
    var vendor = (vs && vs.value) || '', product = (ps && ps.value) || '';
    if (!vendor)  { try { vendor  = localStorage.getItem('eoh_last_vendor')  || ''; } catch (_) {} }
    if (!product) { try { product = localStorage.getItem('eoh_last_product') || ''; } catch (_) {} }
    return { vendor: vendor, product: product };
  }

  /* ═══════════════════ 1) PROMPT STARTERS (welcome chips) ═══════════════════ */
  var _starters = [], _sBusy = false;

  function _welcomeBubble() {
    var feats = document.querySelectorAll('.mbubble .wc-feat');
    if (!feats.length) return null;
    var last = feats[feats.length - 1];
    return last.closest ? last.closest('.mbubble') : null;
  }
  function _useStarter(i) {
    var s = _starters[i]; if (!s) return;
    if (s.send_immediately && typeof window.sendMsg_fromWelcome === 'function') { try { window.sendMsg_fromWelcome(s.prompt_text); return; } catch (_) {} }
    if (typeof window.setQ === 'function') { try { window.setQ(s.prompt_text); return; } catch (_) {} }
    var ta = document.getElementById('chat-ta'); if (ta && !ta.disabled) { ta.value = s.prompt_text; ta.focus(); }
  }
  window._eohStarterUse = _useStarter;

  async function _renderStarters() {
    if (_sBusy) return;
    var bubble = _welcomeBubble();
    if (!bubble || bubble.querySelector('#eoh-starter-chips')) return;
    _sBusy = true;
    try {
      var s = _sel();
      var d = await _getJSON(API + '/chat-inputs/starters?vendor=' + encodeURIComponent(s.vendor) + '&product=' + encodeURIComponent(s.product));
      if (!d || d.enabled === false || !d.starters || !d.starters.length) return;
      bubble = _welcomeBubble(); if (!bubble || bubble.querySelector('#eoh-starter-chips')) return;
      _starters = d.starters;
      var chips = _starters.map(function (x, i) { return '<button class="wc-pill" onclick="_eohStarterUse(' + i + ')">' + (x.icon ? _esc(x.icon) + ' ' : '') + _esc(x.label) + '</button>'; }).join('');
      var block = document.createElement('div');
      block.id = 'eoh-starter-chips'; block.style.margin = '18px 0 4px';
      block.innerHTML = '<p style="margin:0 0 8px;font-size:11px;color:var(--dim)">Quick starters</p><div style="display:flex;flex-wrap:wrap;gap:7px">' + chips + '</div>';
      var feat = bubble.querySelector('.wc-feat'), grid = feat ? feat.parentElement : null;
      if (grid && grid.parentElement) grid.parentElement.insertBefore(block, grid); else bubble.appendChild(block);
    } finally { _sBusy = false; }
  }
  function _initStarters() {
    var msgs = document.getElementById('msgs');
    if (msgs && window.MutationObserver) {
      // Observe ONLY direct children added to #msgs (NOT subtree). Observing the
      // subtree meant every streamed response chunk fired a tree-wide querySelector,
      // which becomes quadratic on long answers and freezes the page. The welcome
      // card is a direct child of #msgs, so inspecting addedNodes is enough + cheap.
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes || [];
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n && n.nodeType === 1 && n.querySelector && n.querySelector('.wc-feat')) {
              if (!document.getElementById('eoh-starter-chips')) _renderStarters();
              return;
            }
          }
        }
      }).observe(msgs, { childList: true });
    }
    ['vs', 'ps'].forEach(function (id) { var el = document.getElementById(id); if (el) el.addEventListener('change', function () { var b = document.getElementById('eoh-starter-chips'); if (b) b.remove(); setTimeout(_renderStarters, 80); }); });
    _renderStarters();
  }

  /* ═══════════════════ 2) SLASH COMMANDS ═══════════════════ */
  async function _initSlash() {
    var d = await _getJSON(API + '/chat-inputs/commands');
    if (!d || d.enabled === false || !d.commands || !d.commands.length) return;
    window._eohSlashCommands = d.commands.map(function (c) {
      return {
        cmd: c.command, icon: c.icon || '⌘', label: c.command, sub: c.description || c.label || '',
        trigger: function (rest) {
          var text = c.template_text + (c.append_args !== false && rest ? rest : '');
          if (typeof window.setQ === 'function') { try { window.setQ(text); return; } catch (_) {} }
          var ta = document.getElementById('chat-ta'); if (ta && !ta.disabled) { ta.value = text; ta.focus(); }
        }
      };
    });
  }

  /* ═══════════════════ 3) @-CONTEXT ATTACH ═══════════════════ */
  var _ctx = null;
  async function _loadCtx() {
    if (_ctx) return _ctx;
    var d = await _getJSON(API + '/chat-inputs/context/list');
    _ctx = { projects: (d && d.projects) || [], files: (d && d.files) || [] };
    return _ctx;
  }
  function _closeCtxMenu() { var m = document.getElementById('eoh-ctx-menu'); if (m) m.remove(); }
  async function _showCtxMenu(query, start, end) {
    var ta = document.getElementById('chat-ta'); if (!ta) return;
    var data = await _loadCtx();
    var q = (query || '').toLowerCase();
    var projs = data.projects.filter(function (p) { return !q || (p.name || '').toLowerCase().indexOf(q) !== -1; }).slice(0, 6);
    var files = data.files.filter(function (f) { return !q || (f.filename || '').toLowerCase().indexOf(q) !== -1; }).slice(0, 6);
    if (!projs.length && !files.length) { _closeCtxMenu(); return; }
    _closeCtxMenu();
    var rect = ta.getBoundingClientRect();
    var menu = document.createElement('div');
    menu.id = 'eoh-ctx-menu';
    menu.style.cssText = 'position:fixed;left:' + rect.left + 'px;bottom:' + (window.innerHeight - rect.top + 6) + 'px;width:' + Math.min(rect.width, 360) + 'px;background:var(--bg2);border:1px solid var(--border2,var(--border));border-radius:10px;z-index:9999;overflow:hidden;max-height:240px;overflow-y:auto;box-shadow:0 8px 32px rgba(0,0,0,.4)';
    function _sec(title) { return '<div style="padding:6px 12px;font-size:10px;text-transform:uppercase;letter-spacing:.05em;color:var(--muted);background:var(--bg3)">' + title + '</div>'; }
    var html = '';
    if (projs.length) { html += _sec('Projects'); projs.forEach(function (p, i) { html += '<div class="eoh-ctx-item" data-t="p" data-i="' + i + '" style="display:flex;gap:9px;align-items:center;padding:9px 12px;cursor:pointer;border-bottom:1px solid var(--border)"><span>📁</span><div style="min-width:0"><div style="font-size:13px;font-weight:600;color:var(--text);white-space:nowrap;overflow:hidden;text-overflow:ellipsis">' + _esc(p.name || 'Project') + '</div><div style="font-size:11px;color:var(--dim)">' + _esc([p.client_name, p.erp_system, p.status].filter(Boolean).join(' · ')) + '</div></div></div>'; }); }
    if (files.length) { html += _sec('Files'); files.forEach(function (f, i) { html += '<div class="eoh-ctx-item" data-t="f" data-i="' + i + '" style="display:flex;gap:9px;align-items:center;padding:9px 12px;cursor:pointer;border-bottom:1px solid var(--border)"><span>📄</span><div style="min-width:0"><div style="font-size:13px;font-weight:600;color:var(--text);white-space:nowrap;overflow:hidden;text-overflow:ellipsis">' + _esc(f.filename || 'File') + '</div><div style="font-size:11px;color:var(--dim)">' + _esc([(f.format || '').toUpperCase(), f.vendor, f.product].filter(Boolean).join(' · ')) + '</div></div></div>'; }); }
    menu.innerHTML = html;
    menu.querySelectorAll('.eoh-ctx-item').forEach(function (el) {
      el.addEventListener('mousedown', function (e) {
        e.preventDefault();
        var before = ta.value.slice(0, start), after = ta.value.slice(end);
        if (el.dataset.t === 'p') {
          // Remove the "@query" token; the project is added as an attachment chip
          // carrying its full compiled context (details, tasks, meetings, files, emails).
          var p = projs[parseInt(el.dataset.i, 10)];
          ta.value = before + after;
          ta.focus(); try { ta.setSelectionRange(before.length, before.length); } catch (_) {}
          ta.dispatchEvent(new Event('input', { bubbles: true }));
          _closeCtxMenu();
          _attachProject(p);
          return;
        }
        var f = files[parseInt(el.dataset.i, 10)];
        var tag = '@[File: ' + (f.filename || '') + '] ';
        ta.value = before + tag + after;
        var pos = (before + tag).length;
        ta.focus(); try { ta.setSelectionRange(pos, pos); } catch (_) {}
        ta.dispatchEvent(new Event('input', { bubbles: true }));
        _closeCtxMenu();
      });
    });
    document.body.appendChild(menu);
  }
  // Real solution: instead of attaching a compiled document (which the edit-file
  // classifier misreads and deflects), set the ACTIVE project id. eoh-chat.js sends
  // it as pm_project_id, and chat.js injects the full project (tasks/meetings/docs/
  // team, scoped by project_id) into the SYSTEM PROMPT — and enables PM actions
  // (create task, schedule meeting, generate document).
  function _clearActiveProject() {
    if (typeof window !== 'undefined') window._eohPmProjectId = null;
    var el = document.getElementById('eoh-active-project'); if (el) el.remove();
  }
  function _showActiveProjectPill(name) {
    var host = document.getElementById('text-input-area') || document.body;
    var el = document.getElementById('eoh-active-project');
    if (!el) {
      el = document.createElement('div');
      el.id = 'eoh-active-project';
      el.style.cssText = 'display:inline-flex;align-items:center;gap:8px;margin:0 0 8px 0;padding:5px 11px;background:var(--bg2,#16202e);border:1px solid var(--gl,#0a8a5f);border-radius:8px;font-size:12px;color:var(--text,#e8eef5);max-width:100%';
      if (host && host.firstChild) host.insertBefore(el, host.firstChild); else host.appendChild(el);
    }
    el.innerHTML = '<span>📁</span><span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">Active project: <strong>' + _esc(name) + '</strong></span>' +
      '<span id="eoh-active-project-x" title="Remove" style="cursor:pointer;color:var(--dim,#8a94a6);font-weight:700;margin-left:2px">✕</span>';
    var x = document.getElementById('eoh-active-project-x'); if (x) x.onclick = _clearActiveProject;
  }
  window._eohClearActiveProject = _clearActiveProject;

  function _attachProject(p) {
    if (!p || !p.id) return;
    if (typeof window !== 'undefined') window._eohPmProjectId = p.id;
    _showActiveProjectPill(p.name || 'Project');
    _ctxNote('✓ Project context active — ask about its tasks, meetings, or documents');
    setTimeout(function () { _ctxNote(''); }, 2400);
  }

  function _onTaInputCtx() {
    var ta = document.getElementById('chat-ta'); if (!ta) return;
    var pos = ta.selectionStart == null ? ta.value.length : ta.selectionStart;
    var upto = ta.value.slice(0, pos);
    var m = upto.match(/@([\w .\-]*)$/);
    if (!m) { _closeCtxMenu(); return; }
    _showCtxMenu(m[1], pos - m[0].length, pos);
  }
  function _initContext() {
    var ta = document.getElementById('chat-ta'); if (!ta) return;
    ta.addEventListener('input', _onTaInputCtx);
    ta.addEventListener('keydown', function (e) { if (e.key === 'Escape') _closeCtxMenu(); });
    document.addEventListener('click', function (e) { if (!e.target.closest('#eoh-ctx-menu') && !e.target.closest('#chat-ta')) _closeCtxMenu(); });
  }

  /* ═══════════════════ 4) INLINE LIMIT METER ═══════════════════ */
  var _maxMb = null;
  async function _initLimitMeter() {
    var cfg = await _getJSON(API + '/upload/config'); _maxMb = (cfg && cfg.max_size_mb) || null;
    var bar = document.getElementById('upload-bar'); if (!bar || !window.MutationObserver) return;
    var docsEl = document.getElementById('upload-docs'), thumbsEl = document.getElementById('upload-thumbs');
    function _update() {
      if (getComputedStyle(bar).display === 'none') return;
      var nd = docsEl ? docsEl.childElementCount : 0, ni = thumbsEl ? thumbsEl.childElementCount : 0;
      var row = bar.querySelector('.upload-status-row') || bar;
      var meter = document.getElementById('eoh-limit-meter');
      if (!meter) { meter = document.createElement('span'); meter.id = 'eoh-limit-meter'; meter.style.cssText = 'margin-left:auto;font-size:11px;color:var(--dim)'; row.appendChild(meter); }
      var parts = [];
      if (ni) parts.push(ni + ' image' + (ni > 1 ? 's' : ''));
      if (nd) parts.push(nd + ' file' + (nd > 1 ? 's' : ''));
      if (_maxMb) parts.push('max ' + _maxMb + ' MB each');
      var txt = parts.join('  ·  ');
      if (meter.textContent !== txt) meter.textContent = txt; // guard: no redundant DOM writes
    }
    // CRITICAL: observe ONLY the count containers (childList) + the bar's style
    // attribute — NOT the bar's whole subtree. Observing the subtree would let the
    // meter's own textContent write re-trigger the observer → infinite loop → the
    // page freezes ("Page Unresponsive").
    var obs = new MutationObserver(_update);
    if (docsEl)   obs.observe(docsEl,   { childList: true });
    if (thumbsEl) obs.observe(thumbsEl, { childList: true });
    obs.observe(bar, { attributes: true, attributeFilter: ['style'] });
    _update();
  }

  /* ═══════════════════ 5) DRAG-AND-DROP UPLOAD ═══════════════════ */
  var IMG_EXT = ['png', 'jpg', 'jpeg', 'webp', 'gif'];
  function _routeFiles(fileList) {
    var imgs = [], docs = [];
    Array.prototype.slice.call(fileList).forEach(function (f) {
      var ext = (f.name || '').split('.').pop().toLowerCase();
      (IMG_EXT.indexOf(ext) !== -1 ? imgs : docs).push(f);
    });
    if (imgs.length && typeof window.handleMultiImages === 'function') {
      var dt = new DataTransfer(); imgs.forEach(function (f) { dt.items.add(f); });
      try { window.handleMultiImages({ target: { files: dt.files, value: '' } }); } catch (_) {}
    }
    if (docs.length && typeof window.handleFile === 'function') {
      var dt2 = new DataTransfer(); docs.forEach(function (f) { dt2.items.add(f); });
      try { window.handleFile({ target: { files: dt2.files, value: '' } }); } catch (_) {}
    }
  }
  function _initDrag() {
    var area = document.getElementById('text-input-area'); if (!area) return;
    var _hl = function (on) { area.style.outline = on ? '2px dashed var(--gl)' : ''; area.style.outlineOffset = on ? '-4px' : ''; };
    area.addEventListener('dragover', function (e) { if (e.dataTransfer && Array.prototype.indexOf.call(e.dataTransfer.types || [], 'Files') !== -1) { e.preventDefault(); _hl(true); } });
    area.addEventListener('dragleave', function (e) { if (e.target === area) _hl(false); });
    area.addEventListener('drop', function (e) {
      if (!e.dataTransfer || !e.dataTransfer.files || !e.dataTransfer.files.length) return;
      e.preventDefault(); _hl(false); _routeFiles(e.dataTransfer.files);
    });
  }

  /* ═══════════════════ BOOT ═══════════════════ */
  async function _boot() {
    var f = await _getJSON(API + '/chat-inputs/features');
    _flags = (f && f.features) || {};
    _initStarters(); // self-gates via /starters enabled flag
    if (_flags.chat_slash_commands   !== false) _initSlash();
    if (_flags.chat_context_attach   !== false) _initContext();
    if (_flags.chat_input_limit_meter !== false) _initLimitMeter();
    if (_flags.chat_drag_drop_upload !== false) _initDrag();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', _boot); else _boot();
})();
